<template>
  <nav class="nav">
    <div class="nav-left">
      <a class="nav-item">
        <img src="/static/logo.png" alt="Bulma logo">
      </a>
    </div>
    <div class="nav-right nav-menu">
      <span class="nav-item">
        <a class="button is-primary is-outlined" v-on:click="logout()">
          <span>SAIR</span>
        </a>
      </span>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'topbar',
  data () {
    return {

    }
  },
  methods: {
    logout(){
      localStorage.removeItem("data")
      localStorage.removeItem("event")
      this.$router.replace('/')
    }
  }
}
</script>

<style scoped>
.nav {
  background-color: rgb(25, 28, 30);
}
.is-custom {

}
</style>



// WEBPACK FOOTER //
// Topbar.vue?c8708fe6